// api.js
import axios from "axios";


const api = axios.create({
  baseURL:  process.env.REACT_APP_BASE_URL,   // change to your API
});

// Request interceptor to add token automatically
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // or cookies, Zustand, Redux, etc.
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// (optional) Response interceptor for catching 401, etc.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("Unauthorized, token expired?");
    //   if (window.AndroidInterface && window.AndroidInterface.onLogout) {
    //     window.AndroidInterface.onLogout();
    // }
      // 🔥 Delete token
      localStorage.removeItem("token");

      // 🔥 Optional: clear other auth-related storage
      localStorage.removeItem("user");

      // 🔥 Redirect to login
      window.location.replace("/login"); 
    }
    return Promise.reject(error);
  }
);

export default api;
